export const View = (props) => {
  return (
    <div className="left-right-card flex-container row">
      <div className="key-text">{props.key_id}</div>
      <div className="value-text">{props.value}</div>
    </div>
  );
};
